<template>
<ContenedorCampos :titulo="titulo" :isObligatorio="Obligatorio" :error="error">
  <v-select
    :disabled="bDeshabilitado"
    label="Seleccione sus opciones"
    v-model="aValue"
    :items="aOptions"
    item-text="DatoMostrar"
    item-value="ID"
    @change="Change"
    :loading="bCargando"
    multiple
    autocomplete
    dense
    outlined
    hide-details
    >
  </v-select>
</ContenedorCampos>
</template>
<script>
import ContenedorCampos from '@/components/dinamicos/ContenedorCampos.vue'
import DinamicosMixin from '@/mixins/dinamicosMixin.js'


export default {
  name: 'MultiSelect',
  mixins: [ DinamicosMixin ],
  components: {
    ContenedorCampos,
  },
  data () {
    return {
      aValue : [],
    }
  },
  async mounted () {
    await this.CargarData()

  },
  methods: {
    Change(){
      this.selectValue = this.aValue
    },
  },
  computed: {
    
  },

}
</script>

<style lang="scss" scoped>

</style>
